module.exports = __webpack_public_path__ + "assets/img/news (15).791c753a.png";